import React from 'react';
import TextQuote from '../components/TextQuote';
import H4Title from '../components/H4Title';

/**
 * Renders the About Us page.
 *
 * @returns {JSX.Element} The About Us page component.
 */
function AboutUsPage() {
  return (
    <div>
    <H4Title text="About Us" />
    <TextQuote text="Welcome to this simple Passport Bros Aggregator, your go-to resource for discovering the best countries for international dating and travel. I created this platform to help others in the community quickly find relevant information about different countries, making it easier to choose your next destination. Currently, I’ve manually curated a list of countries with key data points like safety, cost of living, language, and more. This simple yet powerful tool is designed to help you make informed decisions at a glance." />  
    </div>
    );
}

export default AboutUsPage;
